import {
	Checkbox,
	Elem,
	ElemBefore,
	IconButton,
	SearchSelectOptionProps,
} from "@alm/flow-ds/components";
import { IdData, SelectFieldsType } from "hooks/FormDesigner/useElementList";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AdditionalSelect from "./AdditionalSelect";
import SelectFieldsBasedOnForm from "./SelectFieldsBasedOnForm";

interface Props {
	selectFieldsBasedOnForm: boolean;
	updateSelectFieldsBasedOnForm: (data: SelectFieldsType) => void;
	additionalSelect?: SearchSelectOptionProps[];
	updateAdditionalSelect: (data: SearchSelectOptionProps[]) => void;
	usePatch: boolean;
	idList: IdData;
	isEmu: boolean;
}

const Performance = ({
	selectFieldsBasedOnForm,
	updateSelectFieldsBasedOnForm,
	updateAdditionalSelect,
	additionalSelect,
	usePatch,
	idList,
	isEmu,
}: Props) => {
	const { t } = useTranslation();

	const [isOpen, setIsOpen] = useState(false);

	return (
		<Elem className="elem-performance-panel">
			<ElemBefore label={t("formDesigner.labels.performance")} />
			<div className="performance-panel">
				<div className={`performance-card`}>
					<div className="performance-top">
						<div className="performance-heading">
							<div className="performance-heading__name">
								{t(`formDesigner.labels.performancePanel`)}
							</div>
						</div>
						<div>
							<IconButton
								icon="pencil"
								className={`${
									isOpen
										? "btn-primary"
										: "btn-basic--primary"
								}`}
								label={
									isOpen
										? t("common.labels.close")
										: t("common.labels.edit")
								}
								onClick={() => setIsOpen(!isOpen)}
							/>
						</div>
					</div>
					{isOpen && (
						<div className="performance-content">
							<SelectFieldsBasedOnForm
								selectFieldsBasedOnForm={
									selectFieldsBasedOnForm
								}
								updateSelectFieldsBasedOnForm={
									updateSelectFieldsBasedOnForm
								}
								isEmu={isEmu}
							/>
							<AdditionalSelect
								additionalSelect={additionalSelect}
								idList={idList}
								updateAdditionalSelect={updateAdditionalSelect}
							/>

							{!isEmu && (
								<Checkbox
									id="use-patch"
									label={t("formDesigner.labels.usePatch")}
									value={usePatch.toString()}
									checked={usePatch}
									hint={t("formDesigner.labels.usePatchHint")}
									disabled={true}
									onChange={() =>
										console.error("usePatch clicked")
									}
								/>
							)}
						</div>
					)}
				</div>
			</div>
		</Elem>
	);
};

export default Performance;
